import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable max-len  */
import React from 'react';
import { colors } from '../theme/colors';
export function ExpandRightIcon(props) {
  var _props$background;

  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6001 7.99982C12.6001 8.40941 12.4433 8.81899 12.1314 9.13099L5.73153 15.5308C5.10594 16.1564 4.09477 16.1564 3.46919 15.5308C2.8436 14.9052 2.8436 13.8941 3.46919 13.2685L8.75704 7.98062L3.66918 2.71196C3.0564 2.07358 3.074 1.06401 3.70918 0.449623C4.34436 -0.164761 5.35874 -0.14716 5.97152 0.488023L12.1506 6.88785C12.4513 7.19984 12.6001 7.59983 12.6001 7.99982Z",
      fill: (_props$background = props.background) !== null && _props$background !== void 0 ? _props$background : colors.textForeground
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_2531_2968",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "3",
      y: "0",
      width: "10",
      height: "16",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.6001 7.99982C12.6001 8.40941 12.4433 8.81899 12.1314 9.13099L5.73153 15.5308C5.10594 16.1564 4.09477 16.1564 3.46919 15.5308C2.8436 14.9052 2.8436 13.8941 3.46919 13.2685L8.75704 7.98062L3.66918 2.71196C3.0564 2.07358 3.074 1.06401 3.70918 0.449623C4.34436 -0.164761 5.35874 -0.14716 5.97152 0.488023L12.1506 6.88785C12.4513 7.19984 12.6001 7.59983 12.6001 7.99982Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_2531_2968)",
      children: /*#__PURE__*/_jsx("rect", {
        x: "-4",
        y: "20",
        width: "24",
        height: "24",
        transform: "rotate(-90 -4 20)",
        fill: "#686868"
      })
    })]
  });
}